let localSite = site || {};
localSite.hcpfinder = () => {
    const facetExpandWidth = window.matchMedia('(min-width: 992px)'); // bootstrap 'lg' default value

    const settings = {
        useApiRequest: false,
        mapOpen: false
    };
    const hcpFinderForm = $('#hcp-finder');
    const hcpCardSelector = '.js-hcp-card';
    const loadMoreSelector = '.js-load-more';
    const hcpMapLabelSelector = '.js-hcp-map-label';
    const contactUsSelector = '.js-contact-us';
    const contactUsFormSelector = '#js-contact-us-form';
    const postalCodeFieldSelector = '.js-postal-code';
    const modalSelector = '.js-modal';
    const mapSelector = '#js-map';
    const mapToggle = '.js-map-on';
    const submitBtn = $('.js-submit');
    const searchResults = document.getElementById('js-search-results');
    const count = searchResults.dataset['count'];
    const pageInput = document.getElementById('pageInput');
    const distanceInput = document.getElementById('searchDistance');
    const runSearch = (useApi = false) => {
        settings.useApiRequest = useApi;
        hcpFinderForm.submit();
    };
    const geocoder = new google.maps.Geocoder();
    let map = null;
    let infoWindow = null;
    let markers = [];
    let hcps = [];
    const showHideFacets = function () {
            $('.js-facet-panel').addClass('show');
            $('.js-collapse-icon').attr("aria-expanded", true);
    };
    
    const showHideReset = function () {
        if ($('.js-facet-filter:checked').length === 0) {
            $('.js-filter-reset').addClass('d-none');
        }
        else {
            $('.js-filter-reset').removeClass('d-none');
        }
    };

    const setMapOnAll = (map) => {
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(map);
        }
    };

    const deleteMarkers = () => {
        setMapOnAll(null);
        markers = [];
    };

    const zoomToShowMarkers = () => {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < markers.length; i++) {
            bounds.extend(markers[i].position);
        }
        map.fitBounds(bounds);
    };

    const populateMap = async (mapDiv) => {
        if (settings.mapOpen && hcps.length > 0) {
            loadMap(mapDiv, hcps[0].position);
            hcps.forEach((hcp) => {                      
                const marker = new google.maps.Marker({
                    position: hcp.position,
                    map,
                    label: hcp.label.toString()
                  });
                  markers.push(marker);
                  const infoWindowContent = `<div><span class="rounded-circle text-center bg-danger text-invert d-inline-block mb-1" style="width:30px; height:30px; padding-top:7px;"><a class="text-decoration-none" href='#${hcp.label}'>${hcp.label}</a></span><p class='text-16 fw-bold'>${hcp.name}</p><p>${hcp.address}</p></div>`;
                  google.maps.event.addListener(marker, "click", () => {
                    infoWindow.setContent(infoWindowContent)
                    infoWindow.open(map, marker);
                  });
            });
            zoomToShowMarkers();
        }
    };

    const geocode = (address, count) => {
        count = count || 1;
        return new Promise((resolve, reject) => {                  
            geocoder.geocode({address}, (results, status) => {
                if (status == 'OK') {
                    resolve(results[0].geometry.location);
                } else {
                    if (count <= 10) {
                        count++;
                        setTimeout(()=> geocode(address, count).then(resolve).catch(reject), 2000);
                    } else {
                        reject(status);
                    }
                }
            });
        });
    };

    const lookupPostalCodeForLatLng = (location) => {
        return new Promise((resolve, reject) => {
            geocoder.geocode({location}, (results, status) => {
                if (status === 'OK') {
                    resolve(results.flatMap(r=> r.address_components).find(c=> c.types.indexOf('postal_code') >=0).short_name);
                }

                reject(status);
            });
        });
    };

    const loadMap = (mapDiv, center) => {
        if (map === null){        
            map = new google.maps.Map(mapDiv, { center, zoom: 3 });
            infoWindow = new google.maps.InfoWindow();
        }
        mapDiv.classList.remove('d-none');
        deleteMarkers();
        return map;
    };

    const showMap = async () => {
        showMapLabels();
        const mapDiv = document.querySelector(mapSelector);
        settings.mapOpen = true;
        mapDiv.classList.remove('d-none');
        await geocodeLocations(Array.from(document.querySelectorAll(hcpCardSelector)));
        populateMap(document.querySelector(mapSelector));

    };
    const hideMap = () => {
        hideMapLabels();
        const mapDiv = document.querySelector(mapSelector);
        settings.mapOpen = false;
        mapDiv.classList.add('d-none');
        deleteMarkers();
        hcps = [];
    };

    const showMapLabels = () => {
        const labels = document.querySelectorAll(hcpMapLabelSelector);
        labels.forEach(n => n.classList.remove('d-none'));
        labels.forEach(n => n.classList.add('d-inline-block'));
    };
    const hideMapLabels = () => {
        const labels = document.querySelectorAll(hcpMapLabelSelector);
        labels.forEach(n => n.classList.remove('d-inline-block'));
        labels.forEach(n => n.classList.add('d-none'));
    };

    const geocodeLocations = (hcpElements) => {
        return Promise.all(hcpElements.map(async hcp => {
            const data = { ...JSON.parse(hcp.dataset['info']) };
            data.position = { lat: data.latitude, lng: data.longitude };// await geocode(data.address);
            hcps.push(data);
            return data;
        }));
    }

    const initFacetActions = () => {
        hcpFinderForm.on('click', '.js-facet-filter', () => {
            runSearch();
        });
        hcpFinderForm.on('click', '.js-filter-reset', () => {
            $('.js-facet-filter').attr('checked', false);
            runSearch();
        });
        hcpFinderForm.on('click', '.js-map-on', (event) => {
            if (event.currentTarget.checked) {
                showMap();
                $('.js-map-on').prop('checked', true);
            } else {
                hideMap();
                $('.js-map-on').prop('checked', false);
            }
        });
        $(window).smartresize(function () {
            showHideFacets();
        }, 200);

        $(document).on('click', '.js-facet-filter', function (e) {
            showHideReset();
        });
    };
    const initMapToggleValues = () => {
        var value = document.getElementById("mapOn").checked;
        if (value != false) {
            showMap();
        }
        else {
            hideMap();
        }
    };
    const initLoadMoreActions = () => {
        hcpFinderForm.on('click', '.js-load-more', () => {
            const newValue = 1 + parseInt(pageInput.getAttribute('value'), 10);
            pageInput.setAttribute('value', newValue);
            runSearch(true);
            initMapToggleValues();
        });
    };
  
    const initFormActions = () => {
        submitBtn.click(() => {
            distanceInput.setAttribute('value', 0);
            settings.useApiRequest = false;
            
        });
        hcpFinderForm.submit(() => {
            var formData = hcpFinderForm.serializeArray();

            //only runs on load more
            if (settings.useApiRequest) {
                fetch(`/api/hcpfinder/search?${$.param(formData)}`)
                    .then(result => result.text())
                    .then(result => {
                        searchResults.innerHTML += result;
                        let results = searchResults.querySelectorAll(hcpCardSelector);
                       
                        if (results.length >= count) {
                            const loadMore = document.querySelector(loadMoreSelector);
                            loadMore.classList.add('d-none');
                        }
                        geocodeLocations(Array.from(document.querySelectorAll(hcpCardSelector)).slice(markers.length)).then(results => {                            
                            //showMap();
                            initMapToggleValues();
                        });
                    });
                return false;
            }
            pageInput.remove();
        });
    };

    const initContactUsActions = () => {
        hcpFinderForm.on('click', contactUsSelector, (event) => {
            document.getElementById('js-contact-us-form').classList.remove('d-none');    
            hbspt.forms.create({
                portalId: "4990772",
                target: '#js-contact-us-form',
                formId: "e2f76586-eef0-462c-8dd1-627dc46cb53e",
                onFormSubmit: (form) => {
                    form.find('[name=contact_email_address]').val(event.currentTarget.dataset.email);
                }
            });
        });
    };

    const handleError = (err) => {
        if (err.code == 1) {
            return;
        }
    };

    const getBrowserLocation = () => new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(resolve, handleError);
        }
        else {
            reject(new Error('Geolocation is unsupported'));
        }
    });

    const initResults = async () => {
        const postalCode = $('.js-postal-code').val();
        if (!postalCode) {
            const { coords } = await getBrowserLocation();
            const postalCode = await lookupPostalCodeForLatLng({ lat : coords.latitude, lng: coords.longitude });
            if (postalCode !== null) {
                $(postalCodeFieldSelector).val(postalCode);
                runSearch();
            }
        }
        initMapToggleValues();
        showHideReset();
    };

    const initModalEvents = () => {
        $(modalSelector).on('hidden.bs.modal', () => {
            document.querySelector(contactUsFormSelector).innerHTML = null;
        });
    };

    initResults();
    initLoadMoreActions();
    initFacetActions();
    initFormActions();
    initContactUsActions();
    initModalEvents(); 
};